/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} WelcomeInputs */

const en_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome`)
};

const fr_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenue`)
};

const de_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen`)
};

const it_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benvenuto`)
};

const ru_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добро пожаловать`)
};

const es_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido`)
};

const zh_cn2_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎`)
};

const ja_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いらっしゃいませ`)
};

const hi_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वागत`)
};

const pt_pt2_welcome = /** @type {(inputs: WelcomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bem-vindo`)
};

/**
* | output |
* | --- |
* | "Welcome" |
*
* @param {WelcomeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const welcome = /** @type {((inputs?: WelcomeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<WelcomeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_welcome(inputs)
	if (locale === "de") return de_welcome(inputs)
	if (locale === "it") return it_welcome(inputs)
	if (locale === "ru") return ru_welcome(inputs)
	if (locale === "es") return es_welcome(inputs)
	if (locale === "zh-CN") return zh_cn2_welcome(inputs)
	if (locale === "ja") return ja_welcome(inputs)
	if (locale === "hi") return hi_welcome(inputs)
	if (locale === "pt-PT") return pt_pt2_welcome(inputs)
	return en_welcome(inputs)
});